export default function (input) {
  const regex = /^(\+45|45)?\d{8}$/
  return !!input.match(regex)
}
